import axios from "../../config/axiosConfig";
import { ITEM_LOT_RATE_REQUEST, ITEM_LOT_RATE_REQUEST_FAILURE, CREATE_ITEM_LOT_RATE, DELETE_ITEM_LOT_RATE,
  GET_ITEM_LOT_RATE, UPDATE_ITEM_LOT_RATE, ITEM_LOT_RATE_REQUEST_SUCCESS, GET_ITEM_LOT_RATE_PAGE } from "../types";

export const getItemLotRatesWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ITEM_LOT_RATE_REQUEST });
      const { auth } = getState();
      let params = {
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Item_Id'
      };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/item-lot-rate/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ITEM_LOT_RATE_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getItemLotRates = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ITEM_LOT_RATE_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/item-lot-rate/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ITEM_LOT_RATE, payload: response?.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
    }
  };
};


export const getItemLotRateByRange = () => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        customerId: auth?.user?.Customer_Id,
      };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      
      const response = await axios.get("/item-lot-rate/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};


export const getItemLotRateById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ITEM_LOT_RATE_REQUEST });
    
      return axios.get(`/item-lot-rate/get/${id}`).then((response) => {
        dispatch({ type: ITEM_LOT_RATE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getItemLotRateByItemId = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ITEM_LOT_RATE_REQUEST });
      const { auth } = getState();
      let params = {};
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      if (include) {
        params = { ...params, ...include };
      }
      return axios.get(`/item-lot-rate/get-by-item-id`, { params }).then((response) => {
        dispatch({ type: ITEM_LOT_RATE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getItemLotRateByItemIdLotId = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ITEM_LOT_RATE_REQUEST });
      const { auth } = getState();
      let params = {};
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      if (include) {
        params = { ...params, ...include };
      }
      return axios.get(`/item-lot-rate/get-by-item-id-lot-id`, { params }).then((response) => {
        dispatch({ type: ITEM_LOT_RATE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const checkLotUsedInOtherItem = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ITEM_LOT_RATE_REQUEST });
      const { auth } = getState();
      let params = {};
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      if (include) {
        params = { ...params, ...include };
      }
      return axios.get(`/item-lot-rate/check-lot-used-in-other`, { params }).then((response) => {
        dispatch({ type: ITEM_LOT_RATE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createItemLotRate = (data) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: ITEM_LOT_RATE_REQUEST });
      return axios.post("/item-lot-rate/add", data,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_ITEM_LOT_RATE, payload: response.data });
        } else {
          dispatch({
            type: ITEM_LOT_RATE_REQUEST_FAILURE,
            error: "Bank Payment create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateItemLotRate = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ITEM_LOT_RATE_REQUEST });
      const { auth } = getState();
      return axios.put("/item-lot-rate/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Payment?.Company_Id || auth.company?.id,
            finyearId: data.Payment?.Finyear_Id || auth.finyear?.id,
            customerId: data.Payment?.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_ITEM_LOT_RATE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: ITEM_LOT_RATE_REQUEST_FAILURE,
            error: "Bank Payment update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteItemLotRate = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ITEM_LOT_RATE_REQUEST });
      const { auth } = getState();
      return axios.delete(`/item-lot-rate/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_ITEM_LOT_RATE, id: id });
          const include = ['id', 'Item_Id',].join(',');
          const searchCols = ['Item_Id'].join(',');
          const { itemLotRate: { page, pageSize, search, where } = {} } = getState();
          dispatch(getItemLotRatesWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ITEM_LOT_RATE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};